import styled, { keyframes } from 'styled-components';
import environmentVariables from '../../config/environmentVariables';
const BlueArrow = `${environmentVariables?.cdnUrl}blue_arrow.png`

export const Root = styled.div`
 width:115px;
 min-width:115px;
 position:sticky;
 top:0;
 left:0;
 height:100vh;
 max-height:100vh;
 background-color:${(p) => p.theme.colors.leftSidebarbg};
 /* display:flex;
 flex-direction:column;
 justify-content:space-between; */
 align-items: flex-start;
 /* padding-left: 30px; */
 overflow-y:scroll;
 scrollbar-width: none;
 ::-webkit-scrollbar{
    width:0px;
    height:3px;
 }
 ::-webkit-scrollbar-thumb{
  background-color:${(p) => p.theme.colors.darkvioletColor};
  border-radius:4px;
}
@media(max-width:${(p) => p.theme.screen.sm}){
  display:none;
}
@media(min-width:769px) and (max-width:1200px){
  width:260px;
  min-width:260px;
}
@media(min-width:1201px) and (max-width:1600px){
  width:300px;
  min-width:300px;
}
@media(min-width:1601px){
  width:350px;
  min-width:350px;
}
`;

export const IconWrapper = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
  padding-right: 10px;
 
  ${(p) => p.top && `
   margin-top:${(p.theme.spacing[p.top])};
   @media(max-width:${p.theme.screen.sm}){
    margin-top:${p.theme.spacing.none};
  }
 `};
 ${(p) => p.bottom && `
   margin-bottom:${(p.theme.spacing[p.bottom])};
   @media(max-width:${p.theme.screen.sm}){
    margin-bottom:${p.theme.spacing.none};
  }
`};
cursor:pointer;

`;

export const Text = styled.div`
/* font-size:${(p) => p.theme.font.size.tiny}; */
/* margin-top:${(p) => p.theme.spacing.xs}; */
color: #73777a;
font-weight: 600;
font-size: 15px;
cursor: pointer;

${(p) => p.wallettext && `
  color:#267383;
`};

@media(min-width:1600px){
    /* font-size:${(p) => p.theme.font.size.sm}; */
}
`;

export const LogoWrapper = styled.div`
display:flex;
justify-content:center;
border-bottom: 1px solid #262b2f;
padding: 40px 0;

`;
export const IconCard = styled.div`
  display:flex;
  justify-content:flex-start;
  align-items:center;
  flex-direction:row;
  height: 50px;
  padding: 20px 40px;
  margin: 40px 0;
  cursor:pointer;


  }
  ${Text}{
    ${(p)=> p.selected && `
      color:#1c8399;
    `};
  }
  ${(p) => p.selected && `
    border-right: 2px solid #1b5967;
    width: 100%;
    background-color: #172930;
    
  // background-color:${p.theme.colors.darkvioletColor};
  // padding:${p.theme.spacing.sm} 0;
  `};
  ${(xxx) => 
  xxx.wallett && `
    background-color: #172930;
    border-radius: 5px;
    margin: 40px 20px;
    border: 1px solid #153339;
    padding: 20px 20px;
    color: #267383;
    position: relative;
      &::before {
      content: '';
      position: absolute;
      top: 10px;
      right: 20px;
      width: 28px;
      height: 28px;
      background-image: url(${BlueArrow});
      background-size: cover;
  }

    `};

    &:hover {
      ${(p) => !p.selected && !p.wallett && `
        background-color: #3b3c3324;
      `};
    }

`;

export const Icon = styled.img`
cursor: 'pointer';

 ${(p) => p.width && `
    width:${p.width};
 `};
 ${(p) => p.height && `
    height:${p.height};
 `};
${(p) => p.top && `
   margin-top:${(p.theme.spacing[p.top])};
`};
${(p) => p.bottom && `
   margin-bottom:${(p.theme.spacing[p.bottom])};
`};
@media(max-width:${(p) => p.theme.screen.sm}){
  width:24px;
  height:fit-content;
}
@media(min-width:1600px){
   width:20px !important;
   block-size: fit-content;
   height:fit-content !important;
}

`;

export const Logo = styled.img`
${(p) => p.width && `
    width:${p.width};
 `};
 ${(p) => p.height && `
    height:${p.height};
 `};

@media(max-width:${(p) => p.theme.screen.sm}){
  width:60px;
  height:fit-content;
}
`;


const mymove =keyframes`
from {
  width: 0;
}
to {
  width: 300px;
}
`;
export const MobileView = styled.div`
display:none;
z-index:9999999 !important;
::-webkit-scrollbar {
    display: none;
}

@media(max-width:${(p) => p.theme.screen.sm}){
  overflow-x: hidden;
  overflow-y: scroll;
  display:flex;
  background-color:${(p) => p.theme.colors.cardBgColor};
  height:100vh;
  width:340px;
  min-width:340px;
 
  position:fixed;
  top:0;
  z-index:100;
  flex-direction:column;
  justify-content:left;
  animation-name: ${mymove};
  animation-duration: 0.9s;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
}
}

`;


export const MenuIconWrapper = styled.div`
position:absolute;
left:10px;
top:10px;
font-size:20px;

color:${(p) =>p.theme.colors.white};
cursor:pointer;
display: none;
@media(max-width:${(p) => p.theme.screen.sm}){
  top:35px;
  left:15px;
  display: flex;
}
`;

export const MobileIconWrapper = styled.div`
position: relative;
display:flex;
cursor:pointer;
padding:${(p) => p.theme.spacing.sm};
@media(max-width:768px){
  /* padding: 30px 20px; */
  margin: 15px 0;
  padding: 15 20px;
}
@media(max-width:1024px){
  /* padding: 30px 20px; */
  margin: 15px 0;
  padding: 15 20px;
}
${(p) => p.selected && `
  background-color:  #183a43;
  padding: 15px 20px;
`};

:hover{
  background-color:  #183a43;
  padding: 15px 20px;
}
`;

export const MobileLogoWrapper = styled.div`
display:flex;
align-items:center;
justify-content:left;
padding-left:20px;
cursor:pointer;
@media(max-width:768px){
  padding: 20px;
}
@media(max-width:1024px){
  padding: 20px;
}
`;

export const TextWraper = styled.div`
font-size:${(p) => p.theme.font.size.sm};
margin-left:${(p) =>p.theme.spacing.sm};
`;

export const MobileIcon = styled.img`


`;

export const CloseIconWrapper = styled.div`
  font-size:20px;
  position:absolute;
  top:20px;
  right:20px;
  cursor:pointer;
`;

